import React, { useState } from 'react';
import { Button } from './ui/button';
import { Checkbox } from './ui/checkbox';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from './ui/dialog';
import { FileSpreadsheet, Columns3, Loader2 } from 'lucide-react';

const EXPORT_COLUMNS = [
  { key: 'codigo', label: 'Codigo', default: true },
  { key: 'nome_cliente', label: 'Cliente', default: true },
  { key: 'nif', label: 'NIF', default: true },
  { key: 'empresa', label: 'Empresa', default: true },
  { key: 'tipo_produto', label: 'Tipo Produto', default: true },
  { key: 'tipo_segmento', label: 'Segmento', default: false },
  { key: 'status', label: 'Estado', default: true },
  { key: 'cpe', label: 'CPE', default: false },
  { key: 'cui', label: 'CUI', default: false },
  { key: 'campanha', label: 'Campanha', default: false },
  { key: 'morada_fornecimento', label: 'Morada', default: false },
  { key: 'nr_porta_fornecimento', label: 'Nr Porta', default: false },
  { key: 'andar_fornecimento', label: 'Andar', default: false },
  { key: 'codigo_postal_fornecimento', label: 'Cod. Postal', default: false },
  { key: 'localidade', label: 'Localidade', default: true },
  { key: 'telefones_str', label: 'Telefone', default: false },
  { key: 'emails_str', label: 'Email', default: false },
  { key: 'iban', label: 'IBAN', default: false },
  { key: 'fatura_eletronica', label: 'Fatura Eletronica', default: false },
  { key: 'debito_direto', label: 'Debito Direto', default: false },
  { key: 'data_assinatura', label: 'Data Assinatura', default: false },
  { key: 'proprietario', label: 'Proprietario', default: true },
  { key: 'parceiro', label: 'Parceiro', default: false },
  { key: 'created_at', label: 'Data Criacao', default: false },
  { key: 'observacoes', label: 'Observacoes', default: false },
];

export const ExportDialog = ({ open, onClose, onExport, exporting, title }) => {
  const [selectedCols, setSelectedCols] = useState(
    () => EXPORT_COLUMNS.filter(c => c.default).map(c => c.key)
  );

  const toggleCol = (key) => {
    setSelectedCols(prev =>
      prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );
  };

  const selectAll = () => setSelectedCols(EXPORT_COLUMNS.map(c => c.key));
  const selectNone = () => setSelectedCols(['codigo', 'nome_cliente']);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Columns3 className="w-5 h-5" />
            {title || 'Exportar Excel'}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="flex gap-2">
            <Button variant="outline" size="sm" onClick={selectAll} className="text-xs">
              Seleccionar Todos
            </Button>
            <Button variant="outline" size="sm" onClick={selectNone} className="text-xs">
              Minimo
            </Button>
          </div>
          <div className="grid grid-cols-2 gap-2">
            {EXPORT_COLUMNS.map(col => (
              <label
                key={col.key}
                className="flex items-center gap-2 p-2 rounded-lg hover:bg-slate-50 cursor-pointer text-sm"
              >
                <Checkbox
                  checked={selectedCols.includes(col.key)}
                  onCheckedChange={() => toggleCol(col.key)}
                  data-testid={`export-col-${col.key}`}
                />
                {col.label}
              </label>
            ))}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onClose(false)} className="rounded-full">
            Cancelar
          </Button>
          <Button
            onClick={() => onExport(selectedCols)}
            disabled={exporting || selectedCols.length === 0}
            className="bg-emerald-600 hover:bg-emerald-700 rounded-full gap-2"
            data-testid="confirm-export-btn"
          >
            {exporting ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileSpreadsheet className="w-4 h-4" />}
            Exportar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
